module.exports = __webpack_public_path__ + "img/24_46.3697b407.png";